import { gql } from '@/__generated__';

const GET_DEVICE_PROFILE_STATUS = gql(`#graphql
  query DeviceProfileModal_GetDeviceProfileStatus($input: DeviceInput!) {
    device(input: $input) {
      id
      profile {
        id
        tags {
          tag
        }
      }
      alerts {
        id
        activeConfigurations {
          id
          metric
        }
      }
      hardwareConfiguration {
        id
      }
      metrics {
        id
        flow {
          lastData
        }
        level {
          lastData
        }
        velocity {
          lastData
        }
      }
    }
  }
`);

export default GET_DEVICE_PROFILE_STATUS;
